import React, { useState, useEffect } from 'react'
import Dropzone, { Accept } from 'react-dropzone'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../Notification/Notification'
import i18n from 'live/services/i18n'
import { asyncUpload } from '../../api/preview/edit/asyncUpload'
import { TemplateHeaderPreview } from '../main/options/model/types'

const accept = {
    '.csv': ['*'],
    '.xls': ['*'],
    '.xlsx': ['*'],
    '.xlsb': ['*'],
    '.xlsm': ['*']
} as Accept

function SelectFile({
    setTemplate,
    fileName,
    setFileName
}: {
    setTemplate: (templete: TemplateHeaderPreview) => void
    fileName: string
    setFileName: (fileName: string) => void
}) {
    const [tabOptions, setTabOptions] = useState<TemplateHeaderPreview>()

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setTemplate(tabOptions)
    }, [tabOptions])

    const getFileName = (): string => {
        if (loading) return 'Loading...'
        if (!!fileName) return fileName
        return 'Or choose a file or drag it here'
    }

    return (
        <div
            style={{
                display: 'flex'
            }}
        >
            <div
                style={{
                    height: '40px',
                    marginTop: '7px',
                    padding: '6px 5px',
                    border: '1px dashed var(--gray-700)',
                    width: '100%',
                    overflow: 'auto'
                }}
            >
                <Dropzone
                    key={'default'}
                    onDropAccepted={files => {
                        const file = files[0]
                        setLoading(true)
                        asyncUpload(files[0])
                            .then(result => setTabOptions(result))
                            .then(() => setFileName(file?.name))
                            .catch(error => {
                                setFileName(undefined)
                            })
                            .finally(() => setLoading(false))
                    }}
                    accept={accept}
                    disabled={!!fileName}
                    onDropRejected={files => {
                        if (Array.isArray(files) && files?.length > 1) {
                            GlobalNotification.error(
                                //TODO: set message error
                                <Notification title={i18n('Select 1 file')}>{'Please, select 1 file'}</Notification>,
                                8
                            )
                        }
                    }}
                    maxFiles={1}
                    onDrop={files => {
                        // console.log(files)
                    }}
                    data-cy="drag-and-drop"
                >
                    {({ getRootProps, getInputProps }) => {
                        //TODO: UPDATE MESSAGE
                        return (
                            <span {...getRootProps()}>
                                 <input {...getInputProps()} />
                                <div
                                    style={{
                                        height: '100%',
                                        width: '100%',
                                        padding: '2px 0px 10px 0px'
                                    }}
                                >
                                    <i
                                        className={`far ${loading ? 'fa-spinner fa-spin' : 'fa-file-spreadsheet'}`}
                                        style={{
                                            color: 'var(--gray-600)',
                                            fontSize: '16px',
                                            padding: '2px 4px'
                                        }}
                                    />
                                    <label
                                        style={{
                                            color: 'var(--gray-600)',
                                            display: 'inline-block'
                                        }}
                                    >
                                        {getFileName()}
                                    </label>
                                </div>
                            </span>
                        )
                    }}
                </Dropzone>
            </div>
        </div>
    )
}

export { SelectFile }
